const CottageIcon = /*#__PURE__*/ [
  ["path", { d: "M3 21H21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["circle", { cx: "12", cy: "9", r: "2", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M4 21V11C4 6.58172 7.58172 3 12 3C16.4183 3 20 6.58172 20 11V21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M9 21V18C9 16.1775 10.0596 15 12 15C13.9404 15 15 16.1775 15 18V21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export { CottageIcon as default };
//# sourceMappingURL=CottageIcon.js.map
